<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="12">
        <base-material-card color="primary">
          <template v-slot:heading>
            <h2 class="h1 font-weight-light text_google">
              <v-icon large left>mdi-file-send</v-icon>
              การย้ายสายงานบริหารสถานศึกษา
            </h2>
          </template>

          <!-- ╔══════════════════════════════════════════════════╗ -->
          <!-- ║ [ข้อ 3] แสดงปุ่มยกเลิกรายการด้วยตนเอง          ║ -->
          <!-- ║ แสดงเมื่อ status = Save และระบบยังเปิดอยู่       ║ -->
          <!-- ╚══════════════════════════════════════════════════╝ -->
          <v-card
            class="mb-4"
            v-if="
              (transference_manages.manage_status_save === 'Save' ||
                transference_manages.manage_status_save === 'Confirm') &&
                transference_manages.manage_cancel_status !== 'cancel'
            "
          >
            <v-alert type="success" outlined prominent>
              <v-row align="center">
                <v-col class="grow">
                  <h3>
                    ท่านได้ยืนยันรายการแล้ว รหัสรายการ: {{ manage_id_ref }}
                  </h3>
                  <p v-if="transference_manages.manage_file_attachment">
                    ไฟล์แนบ: {{ transference_manages.manage_file_attachment }}
                  </p>
                  <!-- Show File attachment -->
                  <p v-if="transference_manages.manage_file_attachment">
                    <v-btn
                      color="primary"
                      rounded
                      dark
                      @click="
                        previewFile(transference_manages.manage_file_attachment)
                      "
                    >
                      <v-icon left>mdi-paperclip</v-icon>
                      ดูไฟล์แนบ
                    </v-btn>
                  </p>
                </v-col>
                <v-col class="shrink">
                  <v-btn
                    color="error"
                    large
                    rounded
                    dark
                    @click="showCancelDialog()"
                    :disabled="!isPeriodOpen"
                  >
                    <v-icon left>mdi-cancel</v-icon>
                    ยกเลิกรายการด้วยตนเอง
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="!isPeriodOpen">
                <v-col>
                  <v-chip color="red" dark small>
                    <v-icon left small>mdi-clock-alert</v-icon>
                    หมดเวลาที่ระบบเปิดให้ดำเนินการแล้ว ไม่สามารถยกเลิกได้
                  </v-chip>
                </v-col>
              </v-row>
            </v-alert>
          </v-card>

          <!-- แสดงสถานะยกเลิกแล้ว -->
          <v-card
            class="mb-4"
            v-if="transference_manages.manage_cancel_status === 'cancel'"
          >
            <v-alert type="error" outlined prominent>
              <h3>รายการนี้ถูกยกเลิกแล้ว</h3>
              <p>เหตุผล: {{ transference_manages.manage_cancel_reason }}</p>
              <p>
                วันที่ยกเลิก: {{ transference_manages.manage_cancel_datetime }}
              </p>
            </v-alert>
          </v-card>
          <!-- ═══ จบ ข้อ 3 ส่วนแสดงสถานะ ═══ -->

          <v-card
            v-if="
              transference_manages.manage_status_save !== 'Save' &&
                transference_manages.manage_status_save !== 'Confirm'
            "
          >
            <v-stepper v-model="steps" vertical>
              <!-- ══════════════════════════════════════ -->
              <!-- STEP 1: ข้อมูลเบื้องต้น (เดิม)        -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 1" step="1">
                <div>
                  ข้อมูลเบื้องต้น รหัสรายการอ้างอิง {{ manage_id_ref }}
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                  >
                    <v-icon class="pr-2">mdi-eye</v-icon>
                  </v-btn>
                </div>
              </v-stepper-step>
              <v-stepper-content step="1">
                <v-card>
                  <v-row no-gutters>
                    <v-col cols="12" sm="6">
                      <v-alert
                        border="left"
                        colored-border
                        color="green darken-1"
                        elevation="2"
                        type="info"
                      >
                        <h2>
                          ชื่อ-นามสกุล : {{ user.title_s
                          }}{{ user.frist_name }} {{ user.last_name }}
                        </h2>
                        <h3>รหัสบัตรประชาชน : {{ user.id_card }}</h3>
                        <h3>เลขที่ตำแหน่ง : {{ user.id_position }}</h3>
                        <h3>วิทยฐานะ : {{ user.rang_name }}</h3>
                        <h3>สังกัด (สถานศึกษา) : {{ user.college_name }}</h3>
                        <h3>
                          รับเงินเดือนอันดับ : {{ user.rang_name }} ({{
                            user.rang_level
                          }}) ขั้น
                        </h3>
                        <h3>เงินเดือน : {{ user.salary_s }} บาท</h3>
                        <h3>
                          เกิดวันที่ : {{ user.brith_day }} เดือน
                          {{ user.brith_month }} พ.ศ. {{ user.brith_year }}
                        </h3>
                        <h3>ปัจจุบันอายุ {{ get_Age }}</h3>
                        <hr />
                        <h3>
                          วันที่เริ่มบรรจุเข้ารับราชการ :
                          {{ date_appoin_ch || "-" }}
                        </h3>
                        <h3>
                          ระยะเวลาตั้งแต่บรรจุเข้ารับราชการ : {{ get_gov_Age }}
                        </h3>
                        <h3>สถานะภาพ : {{ marital_status }}</h3>
                      </v-alert>
                    </v-col>
                    <v-col cols="12" sm="6" align="center">
                      <v-alert
                        border="left"
                        colored-border
                        color="green darken-1"
                        elevation="2"
                        type="info"
                      >
                        <h2>ปีงบประมาณ : {{ periods.period_year }}</h2>
                        <h3>เขียนที่ : {{ user.college_name }}</h3>
                        <h3>วันที่ยื่นคำร้อง : {{ date_today }}</h3>
                        <h3>{{ get_gov_Age_year }}</h3>
                        <hr />
                        <div v-if="user.date_app_now === ''">
                          <v-alert prominent type="error">
                            <v-row
                              ><v-col class="grow">
                                <h3>
                                  ให้งานบุคลากร สถานศึกษาของท่าน
                                  ดำเนินการเกี่ยวกับวันที่ปฏิบัติงาน ณ
                                  สถานศึกษาปัจจุบันให้เรียบร้อย
                                </h3>
                              </v-col></v-row
                            >
                          </v-alert>
                        </div>
                        <div v-else>
                          <h3>
                            วันที่เริ่มปฏิบัติหน้าที่ในสถานศึกษาปัจจุบัน :
                            {{
                              user.date_app_now
                                | moment("add", "543 years")
                                | moment("D MMMM YYYY")
                            }}
                          </h3>
                          <h2>
                            ปฏิบัติหน้าที่เป็นเวลา : {{ get_Appoint_Age }}
                          </h2>
                          {{ localTime }}
                        </div>
                      </v-alert>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-alert
                        border="left"
                        colored-border
                        type="error"
                        elevation="2"
                        v-if="user.tel_p === ''"
                      >
                        <h2 class="red--text">
                          กรุณาปรับปรุงข้อมูลติดต่อ เบอร์โทร E-mail
                          ยังหน้าข้อมูลผู้ใช้งานระบบให้เรียบร้อย
                          <v-btn
                            color="red"
                            large
                            rounded
                            dark
                            to="/UserProfile"
                          >
                            <v-icon>mdi-account-circle</v-icon>
                            ข้อมูลผู้ใช้งานระบบ
                          </v-btn>
                        </h2>
                      </v-alert>
                      <v-alert
                        border="left"
                        colored-border
                        type="error"
                        elevation="2"
                        v-if="personnel_work_history_check.count_work === '0'"
                      >
                        <h2 class="red--text">
                          กรุณา บันทึกประวัติการรับราชการให้เรียบร้อย
                          มีผลต่อการพิจารณา
                          <v-btn
                            color="red"
                            large
                            rounded
                            dark
                            to="/personnel_work_history"
                          >
                            <v-icon>mdi-account-circle</v-icon>
                            ประวัติการรับราชการ
                          </v-btn>
                        </h2>
                      </v-alert>
                      <v-alert
                        border="left"
                        colored-border
                        color="green darken-1"
                        elevation="2"
                        type="info"
                      >
                        <v-card
                          v-if="personnel_education_check.count_ed === '0'"
                        >
                          <v-alert prominent type="error">
                            <v-row align="center">
                              <v-col class="grow"
                                ><h2>
                                  ให้ดำเนินการบันทึกข้อมูลคุณวุฒิการศึกษาของท่านเรียบร้อย
                                </h2></v-col
                              >
                              <v-col class="shrink">
                                <v-btn
                                  large
                                  rounded
                                  dark
                                  to="/personnel_education"
                                  ><v-icon>mdi-school</v-icon>
                                  วุฒิการศึกษา</v-btn
                                >
                              </v-col>
                            </v-row>
                          </v-alert>
                        </v-card>
                        <v-card v-else>
                          <v-card-title class="mt-8">
                            <v-avatar size="56"
                              ><v-icon large left
                                >mdi-cast-education</v-icon
                              ></v-avatar
                            >
                            <p class="ml-3">ประวัติการศึกษา</p>
                          </v-card-title>
                          <v-card-text>
                            <v-timeline align-top dense>
                              <v-timeline-item
                                v-for="item in personnel_educations"
                                :key="item.id_red"
                                small
                              >
                                <div>
                                  <div class="font-weight-normal">
                                    {{ item.education_level }} คณะวิชา :
                                    {{ item.faculty_name }} สาขาวิชา :
                                    {{ item.branch_name }} สำเร็จปีการศึกษา :
                                    {{ item.year_finish }}
                                  </div>
                                </div>
                              </v-timeline-item>
                            </v-timeline>
                          </v-card-text>
                        </v-card>
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-card>
                <v-btn
                  @click="addtransference_manageSubmit((steps = 1))"
                  color="primary"
                  >ดำเนินการ</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 2: ความรู้ความสามารถ              -->
              <!-- [ข้อ 1] เพิ่ม validation ต้องกรอก       -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 2" step="2">
                <div>
                  ความรู้ความสามารถในการพัฒนาสถานศึกษา
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="2">
                <v-card>
                  <v-textarea
                    v-model="transference_manages.manage_knowledge"
                    outlined
                    label="ความรู้ความสามารถในการพัฒนาสถานศึกษา *"
                  ></v-textarea>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 2))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 2))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 3: ประสบการณ์                      -->
              <!-- [ข้อ 1] เพิ่ม validation ต้องกรอก       -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 3" step="3">
                <div>
                  ประสบการณ์
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="3">
                <v-card>
                  <v-textarea
                    v-model="transference_manages.manage_experience"
                    outlined
                    label="ประสบการณ์ *"
                  ></v-textarea>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 3))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 1))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 4: ข้อมูลคู่สมรส (เดิม)           -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 4" step="4">
                <div>
                  ข้อมูลคู่สมรส
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="4">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="4"
                      ><v-text-field
                        outlined
                        v-model="transference_manages.manage_spouse"
                        label="คู่สมรสชื่อ : "
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" md="4"
                      ><v-text-field
                        outlined
                        v-model="transference_manages.manage_spouse_occupation"
                        label="คู่สมรสประกอบอาชีพ : "
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" md="4"
                      ><v-text-field
                        outlined
                        v-model="transference_manages.manage_spouse_location"
                        label="สถานที่ประกอบอาชีพของคู่สมรส : "
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" md="4"
                      ><v-autocomplete
                        outlined
                        v-model="transference_manages.manage_domicile"
                        :items="provices_sh"
                        item-text="province_name"
                        item-value="province_ID"
                        label="ภูมิลำเนาของข้าพเจ้า จังหวัด : "
                      ></v-autocomplete
                    ></v-col>
                    <v-col cols="12" md="4"
                      ><v-autocomplete
                        outlined
                        v-model="transference_manages.manage_spouse_domicile"
                        :items="provices_sh"
                        item-text="province_name"
                        item-value="province_ID"
                        label="ภูมิลำเนาของคู่สมรส จังหวัด : "
                      ></v-autocomplete
                    ></v-col>
                  </v-row>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 4))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 1))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 5: ข้อมูลที่อยู่ปัจจุบัน            -->
              <!-- [ข้อ 1] เพิ่ม validation ต้องกรอก       -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 5" step="5">
                <div>
                  ข้อมูลที่อยู่ปัจจุบัน
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="5">
                <v-card class="pa-2">
                  <v-row
                    ><v-col cols="12" md="12">
                      <v-textarea
                        rows="2"
                        outlined
                        v-model="transference_manages.manage_address_now"
                        label="บ้านเลขที่ หมู่ที่ ถนน ตำบล/แขวง อำเภอ/เขต จังหวัด รหัสไปรษณีย์ *"
                      ></v-textarea> </v-col
                  ></v-row>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 5))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 3))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 6: ข้อมูลที่อยู่เมื่อได้ย้ายแล้ว     -->
              <!-- [ข้อ 1] เพิ่ม validation ต้องกรอก       -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 6" step="6">
                <div>
                  ข้อมูลที่อยู่เมื่อได้ย้ายแล้ว
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="6">
                <v-card>
                  <v-textarea
                    rows="2"
                    outlined
                    v-model="transference_manages.manage_after_move"
                    label="บ้านเลขที่ หมู่ที่ ถนน ตำบล/แขวง อำเภอ/เขต จังหวัด รหัสไปรษณีย์ *"
                  ></v-textarea>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 6))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 4))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 7: ข้อมูลติดต่อ (เดิม)            -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 7" step="7">
                <div>
                  ข้อมูลติดต่อ
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="7">
                <v-card class="pa-2">
                  <v-row
                    ><v-col cols="12" md="12">
                      <v-alert
                        border="left"
                        colored-border
                        type="error"
                        elevation="2"
                        v-if="user.tel_p === ''"
                        >กรุณาปรับปรุงข้อมูลยังหน้าข้อมูลผู้ใช้งานระบบ</v-alert
                      >
                      <v-alert
                        border="left"
                        colored-border
                        type="info"
                        elevation="2"
                        v-else
                        >โทรศัพท์ที่สามารถติดต่อได้โดยตรง :
                        {{ user.tel_p }} E-mail : {{ user.e_mail }}</v-alert
                      >
                    </v-col></v-row
                  >
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 7))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 5))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 8: ประวัติการรับราชการ (เดิม)       -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 8" step="8">
                <div>
                  ประวัติการรับราชการ
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="8">
                <v-card>
                  <v-data-table
                    :headers="header_work"
                    :items="personnel_work_history"
                    class="elevation-1"
                  >
                    <template v-slot:item="{ index, item }">
                      <tr>
                        <td class="text-center">{{ index + 1 }}</td>
                        <td class="text-center">
                          {{
                            item.date_begin
                              | moment("add", "543 years")
                              | moment("D MMMM YYYY")
                          }}
                        </td>
                        <td class="text-center">{{ item.position_s }}</td>
                        <td class="text-center">
                          {{ item.college_name_work }}
                        </td>
                        <td class="text-center"></td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 8))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 6))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 9: อยู่ระหว่างลาศึกษาต่อ (เดิม)    -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 9" step="9">
                <div>
                  อยู่ระหว่างลาศึกษาต่อเต็มเวลาหรือไม่
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="9">
                <v-card>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-row>
                        <v-alert
                          class="mx-auto justify-center pa-2 ma-2"
                          border="bottom"
                          colored-border
                          type="warning"
                          elevation="2"
                        >
                          <v-radio-group
                            row
                            v-model="transference_manages.manage_on_study_leave"
                          >
                            <v-radio value="no_leave"
                              ><template v-slot:label
                                ><div>
                                  <strong class="primary--text">ไม่อยู่</strong>
                                </div></template
                              ></v-radio
                            >
                            <v-radio value="leave"
                              ><template v-slot:label
                                ><div>
                                  <strong class="warning--text">อยู่</strong>
                                </div></template
                              ></v-radio
                            >
                          </v-radio-group>
                        </v-alert>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-card class="pa-2 ma-2">
                        <v-row>
                          <v-col cols="12" sm="6"
                            ><v-text-field
                              v-model="
                                transference_manages.manage_study_leave_location
                              "
                              :disabled="
                                transference_manages.manage_on_study_leave ===
                                  'no_leave'
                              "
                              outlined
                              label="อยู่ระหว่างลาศึกษาต่อที่ :"
                              prepend-icon="mdi-office-building-marker"
                            ></v-text-field
                          ></v-col>
                          <v-col cols="12" sm="6"
                            ><v-text-field
                              v-model="
                                transference_manages.manage_study_leave_level
                              "
                              :disabled="
                                transference_manages.manage_on_study_leave ===
                                  'no_leave'
                              "
                              outlined
                              label="เคยลาศึกษาต่อ (ครั้งล่าสุด) ระดับ :"
                              prepend-icon="mdi-office-building-marker"
                            ></v-text-field
                          ></v-col>
                          <v-col cols="12" sm="6"
                            ><v-autocomplete
                              v-model="
                                transference_manages.manage_study_leave_college
                              "
                              outlined
                              :items="colleges"
                              item-text="college_name"
                              item-value="college_code"
                              label="สถานศึกษา"
                              prepend-icon="mdi-office-building-marker"
                              :disabled="
                                transference_manages.manage_on_study_leave ===
                                  'no_leave'
                              "
                          /></v-col>
                          <v-col cols="12" sm="6">
                            <v-dialog
                              ref="dialog_1"
                              v-model="modal_1"
                              :return-value.sync="date"
                              persistent
                              width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }"
                                ><v-text-field
                                  outlined
                                  v-model="
                                    transference_manages.manage_study_leave_start
                                  "
                                  label="ตั้งแต่วันที่ :"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  :disabled="
                                    transference_manages.manage_on_study_leave ===
                                      'no_leave'
                                  "
                                ></v-text-field
                              ></template>
                              <v-date-picker
                                v-model="
                                  transference_manages.manage_study_leave_start
                                "
                                scrollable
                                locale="th"
                                ><v-spacer></v-spacer
                                ><v-btn
                                  text
                                  color="primary"
                                  @click="modal_1 = false"
                                  >Cancel</v-btn
                                ><v-btn
                                  text
                                  color="primary"
                                  @click="$refs.dialog_1.save(date)"
                                  >OK</v-btn
                                ></v-date-picker
                              >
                            </v-dialog>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-dialog
                              ref="dialog_2"
                              v-model="modal_2"
                              :return-value.sync="date"
                              persistent
                              width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }"
                                ><v-text-field
                                  outlined
                                  v-model="
                                    transference_manages.manage_study_leave_end
                                  "
                                  label="ถึงวันที่ :"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  :disabled="
                                    transference_manages.manage_on_study_leave ===
                                      'no_leave'
                                  "
                                ></v-text-field
                              ></template>
                              <v-date-picker
                                v-model="
                                  transference_manages.manage_study_leave_end
                                "
                                scrollable
                                locale="th"
                                ><v-spacer></v-spacer
                                ><v-btn
                                  text
                                  color="primary"
                                  @click="modal_2 = false"
                                  >Cancel</v-btn
                                ><v-btn
                                  text
                                  color="primary"
                                  @click="$refs.dialog_2.save(date)"
                                  >OK</v-btn
                                ></v-date-picker
                              >
                            </v-dialog>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 9))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 7))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 10: ข้อมูลอื่นๆ                    -->
              <!-- [ข้อ 1] เพิ่ม validation ต้องกรอก       -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 10" step="10">
                <div>
                  ข้อมูลอื่น ๆ
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="10">
                <v-card
                  ><v-textarea
                    v-model="transference_manages.manage_performance"
                    outlined
                    label="ผลการปฏิบัติงาน (ระบุ) *"
                  ></v-textarea
                ></v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 10))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 8))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 11: การรักษาวินัย (เดิม)           -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 11" step="11">
                <div>
                  การรักษาวินัยและจรรยาบรรณ
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="11">
                <v-card>
                  <v-alert
                    class="mx-auto justify-center pa-2 ma-2"
                    border="bottom"
                    colored-border
                    type="warning"
                    elevation="2"
                  >
                    <h3>เคยถูกลงโทษทางวินัยหรือไม่</h3>
                    <v-radio-group
                      v-model="transference_manages.manage_disciplinary"
                    >
                      <v-radio value="no_discip"
                        ><template v-slot:label
                          ><div>
                            <strong class="primary--text"
                              >ไม่เคยถูกลงโทษทางวินัย</strong
                            >
                          </div></template
                        ></v-radio
                      >
                      <v-radio value="discip"
                        ><template v-slot:label>
                          <div>
                            <strong class="warning--text"
                              >เคยถูกลงโทษทางวินัย</strong
                            >
                          </div>
                          <v-checkbox
                            v-model="transference_manages.manage_disciplinary_1"
                            label="ภาคทัณ์"
                            value="1"
                            :disabled="
                              transference_manages.manage_disciplinary ===
                                'no_discip'
                            "
                          ></v-checkbox>
                          <v-checkbox
                            v-model="transference_manages.manage_disciplinary_2"
                            label="ตัดเงินเดือน"
                            value="1"
                            :disabled="
                              transference_manages.manage_disciplinary ===
                                'no_discip'
                            "
                          ></v-checkbox>
                          <v-checkbox
                            v-model="transference_manages.manage_disciplinary_3"
                            label="ลดเงินเดือน"
                            value="1"
                            :disabled="
                              transference_manages.manage_disciplinary ===
                                'no_discip'
                            "
                          ></v-checkbox> </template
                      ></v-radio>
                    </v-radio-group>
                  </v-alert>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 11))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 9))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 12: เคยถูกพิจารณาใบประกอบวิชาชีพ (เดิม) -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 12" step="12">
                <div>
                  เคยถูกพิจารณาเกี่ยวกับการประกอบวิชาชีพครู/ผู้บริหารสถานศึกษาหรือไม่
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="12">
                <v-card>
                  <v-radio-group v-model="transference_manages.manage_license">
                    <v-radio value="no_license"
                      ><template v-slot:label
                        ><div>
                          <strong class="primary--text">ไม่เคย</strong>
                        </div></template
                      ></v-radio
                    >
                    <v-radio value="license"
                      ><template v-slot:label>
                        <div><strong class="warning--text">เคย</strong></div>
                        <v-checkbox
                          v-model="transference_manages.manage_license_1"
                          label="ตักเตือน"
                          value="1"
                          :disabled="
                            transference_manages.manage_license === 'no_license'
                          "
                        ></v-checkbox>
                        <v-checkbox
                          v-model="transference_manages.manage_license_2"
                          label="ภาคทัณฑ์"
                          value="1"
                          :disabled="
                            transference_manages.manage_license === 'no_license'
                          "
                        ></v-checkbox>
                        <v-checkbox
                          v-model="transference_manages.manage_license_3"
                          label="พักใช้ใบอนุญาต"
                          value="1"
                          :disabled="
                            transference_manages.manage_license === 'no_license'
                          "
                        ></v-checkbox>
                        <v-checkbox
                          v-model="transference_manages.manage_license_4"
                          label="เพิกถอนใบอนุญาต"
                          value="1"
                          :disabled="
                            transference_manages.manage_license === 'no_license'
                          "
                        ></v-checkbox> </template
                    ></v-radio>
                  </v-radio-group>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 12))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 10))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════════════ -->
              <!-- STEP 13: ปริมาณงาน                             -->
              <!-- [ข้อ 5] จำนวนนักเรียนรวม = ปวช+ปวส+ระยะสั้น   -->
              <!--         คำนวณอัตโนมัติ กรอกเป็นตัวเลข           -->
              <!-- ══════════════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 13" step="13">
                <div>
                  ปริมาณงานหน่วยงานการศึกษาปัจจุบัน
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="13">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="transference_manages.manage_personnel"
                        outlined
                        label="จำนวนบุคลากร คน:"
                        prepend-icon="mdi-account-tie"
                        type="number"
                        min="0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="transference_manages.manage_classroom"
                        outlined
                        label="จำนวนห้องเรียน ห้อง:"
                        prepend-icon="mdi-door"
                        type="number"
                        min="0"
                      ></v-text-field>
                    </v-col>
                    <!-- [ข้อ 5] กรอกตัวเลข ปวช. ปวส. ระยะสั้น แล้วคำนวณรวมอัตโนมัติ -->
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model.number="transference_manages.manage_std_vc"
                        outlined
                        label="ปวช. จำนวน คน:"
                        prepend-icon="mdi-account-group"
                        type="number"
                        min="0"
                        @input="calculateTotalStudents()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model.number="transference_manages.manage_std_hvc"
                        outlined
                        label="ปวส. จำนวน คน:"
                        prepend-icon="mdi-account-group"
                        type="number"
                        min="0"
                        @input="calculateTotalStudents()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model.number="transference_manages.manage_std_sc"
                        outlined
                        label="ระยะสั้น จำนวน คน:"
                        prepend-icon="mdi-account-group"
                        type="number"
                        min="0"
                        @input="calculateTotalStudents()"
                      ></v-text-field>
                    </v-col>
                    <!-- [ข้อ 5] แสดงจำนวนนักเรียนรวม (อ่านอย่างเดียว คำนวณอัตโนมัติ) -->
                    <v-col cols="12" md="12">
                      <v-alert type="info" outlined class="text-center">
                        <h2>
                          จำนวนนักเรียนรวม:
                          <strong class="primary--text">{{
                            transference_manages.manage_std_all || 0
                          }}</strong>
                          คน
                        </h2>
                        <span
                          >(ปวช. {{ transference_manages.manage_std_vc || 0 }} +
                          ปวส. {{ transference_manages.manage_std_hvc || 0 }} +
                          ระยะสั้น
                          {{ transference_manages.manage_std_sc || 0 }})</span
                        >
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 13))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 11))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 14: อยู่ระหว่างช่วยปฏิบัติราชการ (เดิม) -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 14" step="14">
                <div>
                  อยู่ระหว่างช่วยปฏิบัติราชการหรือไม่
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="14">
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-row>
                      <v-alert
                        class="mx-auto justify-center pa-2 ma-2"
                        border="bottom"
                        colored-border
                        type="warning"
                        elevation="2"
                      >
                        <v-radio-group
                          row
                          v-model="transference_manages.manage_service_status"
                        >
                          <v-radio value="not_service"
                            ><template v-slot:label
                              ><div>
                                <strong class="primary--text">ไม่อยู่</strong>
                              </div></template
                            ></v-radio
                          >
                          <v-radio value="gov_service"
                            ><template v-slot:label
                              ><div>
                                <strong class="warning--text"
                                  >ช่วยปฏิบัติราชการ</strong
                                >
                              </div></template
                            ></v-radio
                          >
                        </v-radio-group>
                      </v-alert>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-card class="pa-2 ma-2">
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-autocomplete
                            v-model="transference_manages.manage_service_status"
                            outlined
                            :items="colleges"
                            item-text="college_name"
                            item-value="college_code"
                            label="ช่วยปฏิบัติราชการที่ :"
                            prepend-icon="mdi-office-building-marker"
                            :disabled="
                              transference_manages.manage_service_status ===
                                'not_service'
                            "
                          />
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-dialog
                            ref="dialog_3"
                            v-model="modal_3"
                            :return-value.sync="date"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }"
                              ><v-text-field
                                outlined
                                v-model="
                                  transference_manages.manage_service_datetime
                                "
                                label="ตั้งแต่วันที่ :"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :disabled="
                                  transference_manages.manage_service_status ===
                                    'not_service'
                                "
                              ></v-text-field
                            ></template>
                            <v-date-picker
                              v-model="
                                transference_manages.manage_service_datetime
                              "
                              scrollable
                              locale="th"
                              ><v-spacer></v-spacer
                              ><v-btn
                                text
                                color="primary"
                                @click="modal_3 = false"
                                >Cancel</v-btn
                              ><v-btn
                                text
                                color="primary"
                                @click="$refs.dialog_3.save(date)"
                                >OK</v-btn
                              ></v-date-picker
                            >
                          </v-dialog>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 14))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 12))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 15: ขอย้ายกรณี ปกติ/พิเศษ (เดิม)  -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 15" step="15">
                <div>
                  ขอย้ายกรณี
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="15">
                <v-card>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-alert
                        class="mx-auto justify-center pa-2 ma-2"
                        border="bottom"
                        colored-border
                        type="warning"
                        elevation="2"
                      >
                        <v-radio-group
                          row
                          v-model="transference_manages.manage_case_move"
                        >
                          <v-radio value="normal"
                            ><template v-slot:label
                              ><div>
                                <strong
                                  class="primary--text"
                                  @click="clearCasemove()"
                                  >ปกติ</strong
                                >
                              </div></template
                            ></v-radio
                          >
                          <v-radio value="special"
                            ><template v-slot:label
                              ><div>
                                <strong class="warning--text">พิเศษ</strong>
                              </div></template
                            ></v-radio
                          >
                        </v-radio-group>
                      </v-alert>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <!-- กรณีปกติ -->
                      <v-card
                        class="pa-2 ma-2"
                        v-if="
                          transference_manages.manage_case_move === 'normal'
                        "
                      >
                        <v-card-title
                          ><div
                            class="font-weight-light v-size--x-large"
                            color="pink darken-2"
                          >
                            <v-icon large left>mdi-account-details</v-icon>
                            เหตุผลการขอย้าย กรณีปกติ
                          </div></v-card-title
                        >
                        <v-col cols="12" sm="12">
                          <v-card class="pa-2">
                            <v-card-text>
                              <v-row align="center">
                                <v-card-title
                                  ><div
                                    class="font-weight-light v-size--x-large"
                                  >
                                    ย้ายเพื่ออยู่ร่วมคู่สมรส
                                  </div></v-card-title
                                >
                                <v-checkbox
                                  v-model="transference_manages.manage_reason_1"
                                  value="1"
                                  hide-details
                                  class="shrink mr-2 mt-0"
                                ></v-checkbox>
                                <v-text-field
                                  v-model="
                                    transference_manages.manage_reason_1_spouse
                                  "
                                  :disabled="
                                    !transference_manages.manage_reason_1
                                  "
                                  label="คู่สมรสชื่อ : ชื่อ-นามสกุล"
                                ></v-text-field>
                                <v-text-field
                                  v-model="
                                    transference_manages.manage_reason_1_occupation
                                  "
                                  :disabled="
                                    !transference_manages.manage_reason_1
                                  "
                                  label="คู่สมรสประกอบอาชีพ : "
                                ></v-text-field>
                                <v-text-field
                                  v-model="
                                    transference_manages.manage_reason_1_location
                                  "
                                  :disabled="
                                    !transference_manages.manage_reason_1
                                  "
                                  label="สถานที่ประกอบอาชีพของคู่สมรส : "
                                ></v-text-field>
                                <v-autocomplete
                                  v-model="
                                    transference_manages.manage_reason_1_domicile
                                  "
                                  :items="provices_sh"
                                  item-text="province_name"
                                  item-value="province_ID"
                                  :disabled="
                                    !transference_manages.manage_reason_1
                                  "
                                  label="ภูมิลำเนาของคู่สมรส จังหวัด : "
                                ></v-autocomplete>
                              </v-row>
                              <v-row align="center">
                                <v-card-title
                                  ><div
                                    class="font-weight-light v-size--x-large"
                                  >
                                    ย้ายเพื่อดูแลบิดา มารดา :
                                  </div></v-card-title
                                >
                                <v-checkbox
                                  v-model="transference_manages.manage_reason_2"
                                  value="1"
                                  hide-details
                                  class="shrink mr-2 mt-0"
                                ></v-checkbox>
                                <v-autocomplete
                                  :items="manage_reason_2_years"
                                  item-text="text"
                                  item-value="value"
                                  v-model="
                                    transference_manages.manage_reason_2_fyear
                                  "
                                  :disabled="
                                    !transference_manages.manage_reason_2
                                  "
                                  label="อายุของบิดาปี"
                                ></v-autocomplete>
                                <v-autocomplete
                                  :items="manage_reason_2_years"
                                  item-text="text"
                                  item-value="value"
                                  v-model="
                                    transference_manages.manage_reason_2_myear
                                  "
                                  :disabled="
                                    !transference_manages.manage_reason_2
                                  "
                                  label="อายุของมารดาปี"
                                ></v-autocomplete>
                                <v-autocomplete
                                  v-model="
                                    transference_manages.manage_reason_2_domicile
                                  "
                                  :items="provices_sh"
                                  item-text="province_name"
                                  item-value="province_ID"
                                  :disabled="
                                    !transference_manages.manage_reason_2
                                  "
                                  label="ภูมิลำเนาของบิดา มารดา จังหวัด : "
                                ></v-autocomplete>
                              </v-row>
                              <v-row align="center">
                                <v-card-title
                                  ><div
                                    class="font-weight-light v-size--x-large"
                                  >
                                    ย้ายกลับภูมิลำเนาของข้าพเจ้า จังหวัด :
                                  </div></v-card-title
                                >
                                <v-checkbox
                                  v-model="transference_manages.manage_reason_3"
                                  value="1"
                                  hide-details
                                  class="shrink mr-2 mt-0"
                                ></v-checkbox>
                                <v-autocomplete
                                  v-model="
                                    transference_manages.manage_reason_3_domicile
                                  "
                                  :items="provices_sh"
                                  item-text="province_name"
                                  item-value="province_ID"
                                  :disabled="
                                    !transference_manages.manage_reason_3
                                  "
                                  label="ภูมิลำเนาของข้าพเจ้า จังหวัด : "
                                ></v-autocomplete>
                              </v-row>
                              <v-row align="center">
                                <v-card-title
                                  ><div
                                    class="font-weight-light v-size--x-large"
                                  >
                                    เหตุผลอื่น :
                                  </div></v-card-title
                                >
                                <v-checkbox
                                  v-model="transference_manages.manage_reason_4"
                                  value="1"
                                  hide-details
                                  class="shrink mr-2 mt-0"
                                ></v-checkbox>
                                <v-textarea
                                  v-model="
                                    transference_manages.manage_reason_4_detail
                                  "
                                  :disabled="
                                    !transference_manages.manage_reason_4
                                  "
                                  label="(ระบุ) : "
                                ></v-textarea>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-card>
                      <!-- กรณีพิเศษ -->
                      <v-card
                        class="pa-2 ma-2"
                        v-if="
                          transference_manages.manage_case_move === 'special'
                        "
                      >
                        <v-row
                          ><v-col cols="12" sm="12" class="pa-5">
                            <v-card-title
                              ><div
                                class="font-weight-light v-size--x-large"
                                color="pink darken-2"
                              >
                                <v-icon large left>mdi-account-details</v-icon>
                                เหตุผลการขอย้าย กรณีพิเศษ
                              </div></v-card-title
                            >
                            <v-card class="pa-2"
                              ><v-card-text>
                                <v-row align="center">
                                  <v-card-title
                                    ><div
                                      class="font-weight-light v-size--x-large"
                                    >
                                      ย้ายเพื่อติดตามคู่สมรส เจ็บป่วยร้ายแรง
                                    </div></v-card-title
                                  >
                                  <v-checkbox
                                    v-model="
                                      transference_manages.manage_reason_1_sp
                                    "
                                    value="1"
                                    hide-details
                                    class="shrink mr-2 mt-0"
                                  ></v-checkbox>
                                  <v-text-field
                                    v-model="
                                      transference_manages.manage_reason_1_sp_case
                                    "
                                    :disabled="
                                      !transference_manages.manage_reason_1_sp
                                    "
                                    label="เนื่องจาก"
                                  ></v-text-field>
                                </v-row>
                                <v-row align="center">
                                  <v-card-title
                                    ><div
                                      class="font-weight-light v-size--x-large"
                                    >
                                      ย้ายเพื่อดูแลบิดามารดา คู่สมรส หรือบุตร
                                      ซึ่งเจ็บป่วยร้ายแรงหรือทุพพลภาพ:
                                    </div></v-card-title
                                  >
                                  <v-checkbox
                                    v-model="
                                      transference_manages.manage_reason_2_sp
                                    "
                                    value="1"
                                    hide-details
                                    class="shrink mr-2 mt-0"
                                  ></v-checkbox>
                                  <v-text-field
                                    v-model="
                                      transference_manages.manage_reason_2_sp_case
                                    "
                                    :disabled="
                                      !transference_manages.manage_reason_2_sp
                                    "
                                    label="เนื่องจาก"
                                  ></v-text-field>
                                </v-row>
                                <v-row align="center">
                                  <v-card-title
                                    ><div
                                      class="font-weight-light v-size--x-large"
                                    >
                                      ถูกคุกคามต่อชีวิต :
                                    </div></v-card-title
                                  >
                                  <v-checkbox
                                    v-model="
                                      transference_manages.manage_reason_3_sp
                                    "
                                    value="1"
                                    hide-details
                                    class="shrink mr-2 mt-0"
                                  ></v-checkbox>
                                  <v-text-field
                                    v-model="
                                      transference_manages.manage_reason_3_case
                                    "
                                    :disabled="
                                      !transference_manages.manage_reason_3_sp
                                    "
                                    label="รายละเอียด: "
                                  ></v-text-field>
                                </v-row>
                                <v-row align="center">
                                  <v-textarea
                                    v-model="
                                      transference_manages.manage_case_detail
                                    "
                                    outlined
                                    prepend-icon="mdi-office-building-marker"
                                    rows="2"
                                    label="พิเศษ กรณีอื่น ๆ :"
                                    :disabled="
                                      transference_manages.manage_case_move ===
                                        'normal'
                                    "
                                  ></v-textarea>
                                </v-row> </v-card-text
                            ></v-card> </v-col
                        ></v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 15))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 13))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════════════════ -->
              <!-- STEP 16: ประสงค์ขอย้ายไปดำรงตำแหน่งที่              -->
              <!-- [ข้อ 6] ต้องเลือกหน่วยงานอย่างน้อย 1 แห่ง         -->
              <!-- ══════════════════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 16" step="16">
                <div>
                  ข้าพเจ้ามีความประสงค์ขอย้ายไปดำรงตำแหน่งที่
                  <!-- [ข้อ 6] แสดง chip เตือนหากยังไม่เลือก -->
                  <v-chip
                    color="red"
                    dark
                    small
                    v-if="transference_manage_locations.length === 0"
                    class="ml-2"
                    >* ต้องเลือกอย่างน้อย 1 แห่ง</v-chip
                  >
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="16">
                <v-card class="pa-2 ma-2">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-card class="px-5 py-3">
                        <v-btn
                          x-large
                          color="success"
                          dark
                          rounded
                          @click.stop="
                            addtransference_manage_locationdialogsubmit()
                          "
                        >
                          <v-icon>mdi-selection-multiple-marker</v-icon
                          ><span> เลือกหน่วยงานแห่งใหม่</span>
                        </v-btn>
                        <!-- [ข้อ 6] แสดงเตือนหากยังไม่เลือก -->
                        <v-alert
                          type="warning"
                          outlined
                          class="mt-3"
                          v-if="transference_manage_locations.length === 0"
                        >
                          <v-icon left>mdi-alert</v-icon>
                          กรุณาเลือกหน่วยงานที่ประสงค์ขอย้ายไปอย่างน้อย 1 แห่ง
                        </v-alert>
                        <v-data-table
                          :headers="header_trans"
                          :items="transference_manage_locations"
                        >
                          <template v-slot:item.action="{ item }">
                            <v-icon
                              color="red"
                              @click.stop="
                                transference_manage_locationDelete(
                                  item.manage_location_id_tfl
                                )
                              "
                              >mdi-delete</v-icon
                            >
                          </template>
                        </v-data-table>
                        <v-card class="pa-2 ma-2">
                          <v-card-title
                            ><div class="font-weight-light v-size--x-large">
                              <v-icon large left
                                >mdi-office-building-marker</v-icon
                              >
                              ถ้าไม่ได้ตามที่ระบุ
                            </div></v-card-title
                          >
                          <v-row>
                            <v-col cols="12" sm="12"
                              ><v-row>
                                <v-alert
                                  class="mx-auto justify-center pa-2 ma-2"
                                  border="bottom"
                                  colored-border
                                  type="warning"
                                  elevation="2"
                                >
                                  <v-radio-group
                                    row
                                    v-model="
                                      transference_manages.manage_move_if
                                    "
                                  >
                                    <v-radio value="suspend"
                                      ><template v-slot:label
                                        ><div>
                                          <strong
                                            class="primary--text"
                                            v-on:click="clear_gov_service()"
                                            >ขอระงับการย้าย</strong
                                          >
                                        </div></template
                                      ></v-radio
                                    >
                                    <v-radio value="another"
                                      ><template v-slot:label
                                        ><div>
                                          <strong class="warning--text"
                                            >หน่วยงานการศึกษาใดก็ได้ใน</strong
                                          >
                                        </div></template
                                      ></v-radio
                                    >
                                  </v-radio-group>
                                </v-alert>
                              </v-row></v-col
                            >
                            <v-col cols="12" sm="12"
                              ><v-card class="pa-2 ma-2"
                                ><v-row
                                  ><v-col cols="12" sm="12">
                                    <v-autocomplete
                                      v-model="
                                        transference_manages.manage_move_if_detail
                                      "
                                      :items="provices_sh"
                                      item-text="province_name"
                                      item-value="province_ID"
                                      outlined
                                      prepend-icon="mdi-office-building-marker"
                                      label="สอจ. :"
                                      :disabled="
                                        transference_manages.manage_move_if ===
                                          'suspend'
                                      "
                                    ></v-autocomplete> </v-col></v-row></v-card
                            ></v-col>
                          </v-row>
                        </v-card>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="12"
                      ><h3>
                        ขอย้ายสับเปลี่ยนกับ :
                        {{ personnel_temporarys.title_s }}
                        {{ personnel_temporarys.frist_name }}
                        {{ personnel_temporarys.last_name }}
                      </h3></v-col
                    >
                    <v-col cols="12" sm="6"
                      ><v-text-field
                        v-model="transference_manages.manage_switch_position"
                        :counter="13"
                        outlined
                        label="บัตรประชาชน"
                        prepend-icon="mdi-account-details"
                        v-on:keyup.enter="OnEnter()"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" sm="3"
                      ><v-text-field
                        :value="personnel_temporarys.position_name"
                        outlined
                        label="ตำแหน่ง :"
                        prepend-icon="mdi-account-star"
                        disabled
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" sm="3"
                      ><v-text-field
                        :value="personnel_temporarys.rang_name"
                        outlined
                        label="วิทยฐานะ :"
                        prepend-icon="mdi-account-details"
                        disabled
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" sm="4"
                      ><v-text-field
                        :value="personnel_temporarys.id_position"
                        outlined
                        label="เลขที่ตำแหน่ง :"
                        prepend-icon="mdi-account-details"
                        disabled
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" sm="4"
                      ><v-text-field
                        :value="personnel_temporarys.salary_s"
                        outlined
                        label="เงินเดือน :"
                        prepend-icon="mdi-account-details"
                        disabled
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" sm="4"
                      ><v-text-field
                        :value="personnel_temporarys.college_name"
                        outlined
                        label="สังกัด :"
                        prepend-icon="mdi-flag-letiant"
                        disabled
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" sm="12"
                      ><span
                        >*
                        กรณีย้ายสับเปลี่ยนให้กรอกหมายเลขบัตรประจำตัวประชาชนของผู้ที่ท่านประสงค์สับเปลี่ยน
                        และกดปุ่ม Enter เพื่อดำเนินการค้นหา</span
                      ></v-col
                    >
                  </v-row>
                </v-card>
                <!-- [ข้อ 6] ปุ่มบันทึกมี validate ต้องเลือกอย่างน้อย 1 แห่ง -->
                <v-btn @click="validateAndSaveStep16()" color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 14))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 17: หลักฐานประกอบการพิจารณา (เดิม) -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 17" step="17">
                <div>
                  หลักฐานประกอบการพิจารณา
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="17">
                <v-card>
                  <v-row
                    ><v-col cols="12" sm="12"
                      ><v-row class="pa-4 mt-0">
                        <v-col cols="12" sm="4"
                          ><v-checkbox
                            v-model="
                              transference_manages.manage_evidence_info_1
                            "
                            value="1"
                            label="สำเนา กพ.7/ก.ค.ศ.16"
                          ></v-checkbox
                        ></v-col>
                        <v-col cols="12" sm="4"
                          ><v-checkbox
                            v-model="
                              transference_manages.manage_evidence_info_2
                            "
                            value="1"
                            label="สำเนาทะเบียนบ้านของตน"
                          ></v-checkbox
                        ></v-col>
                        <v-col cols="12" sm="4"
                          ><v-checkbox
                            v-model="
                              transference_manages.manage_evidence_info_3
                            "
                            value="1"
                            label="สำเนาใบสำคัญการสมรส"
                          ></v-checkbox
                        ></v-col>
                        <v-col cols="12" sm="4"
                          ><v-checkbox
                            v-model="
                              transference_manages.manage_evidence_info_4
                            "
                            value="1"
                            label="ใบรับรองแพทย์"
                          ></v-checkbox
                        ></v-col>
                        <v-col cols="12" sm="4"
                          ><v-checkbox
                            v-model="
                              transference_manages.manage_evidence_info_5
                            "
                            value="1"
                            label="บันทึกประจำวัน ตำรวจ/ฝ่ายปกครอง"
                          ></v-checkbox
                        ></v-col>
                        <v-col cols="12" sm="4"
                          ><v-checkbox
                            v-model="
                              transference_manages.manage_evidence_info_6
                            "
                            value="1"
                            label="บันทึกข้อตกลงของผู้ขอย้ายสับเปลี่ยนทุกคน"
                          ></v-checkbox
                        ></v-col>
                        <v-col cols="12" sm="4"
                          ><v-checkbox
                            v-model="
                              transference_manages.manage_evidence_info_7
                            "
                            value="1"
                            label="วิสัยทัศน์ในการบริหารจัดการศึกษา"
                          ></v-checkbox
                        ></v-col>
                        <v-col cols="12" sm="8">
                          <v-row align="center">
                            <v-card-title
                              ><div class="font-weight-light v-size--x-large">
                                อื่นๆ :
                              </div></v-card-title
                            >
                            <v-checkbox
                              v-model="
                                transference_manages.manage_evidence_info_8
                              "
                              value="1"
                              hide-details
                              class="shrink mr-2 mt-0"
                            ></v-checkbox>
                            <v-textarea
                              outlined
                              v-model="
                                transference_manages.manage_evidence_info_8_detail
                              "
                              :disabled="
                                !transference_manages.manage_evidence_info_8
                              "
                              label="(ระบุ) : "
                            ></v-textarea>
                          </v-row>
                        </v-col> </v-row></v-col
                  ></v-row>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 17))"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference((step = 15))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════ -->
              <!-- STEP 18: เหตุผลการขอย้าย อื่นๆ เพิ่มเติม -->
              <!-- (ขั้นตอนสุดท้ายเดิม → ยืนยันข้อมูล)      -->
              <!-- ══════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 18" step="18">
                <div>
                  เหตุผลการขอย้าย อื่นๆ เพิ่มเติม
                  <v-btn
                    icon
                    rounded
                    color="secondary"
                    @click="previewReportShow()"
                    ><v-icon class="pr-2">mdi-eye</v-icon></v-btn
                  >
                </div>
              </v-stepper-step>
              <v-stepper-content step="18">
                <v-card
                  ><v-textarea
                    outlined
                    v-model="transference_manages.manage_reason_detail"
                    label="(ระบุ) : "
                  ></v-textarea
                ></v-card>
                <v-btn
                  @click="updatetransference_manageSubmit((step = 18))"
                  color="primary"
                  >บันทึก (ยืนยันข้อมูลทั้งหมด)</v-btn
                >
                <v-btn text @click="canceltransference((step = 16))"
                  >ยกเลิก</v-btn
                >
              </v-stepper-content>

              <!-- ══════════════════════════════════════════════ -->
              <!-- STEP 19: แนบไฟล์แบบคำร้อง [ข้อ 2] ★ ใหม่ ★   -->
              <!-- ══════════════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 19" step="19">
                <div>
                  แนบไฟล์แบบคำร้องประสงค์ย้าย
                  <v-chip
                    v-if="transference_manages.manage_file_attachment"
                    color="green"
                    dark
                    small
                    class="ml-2"
                  >
                    <v-icon left small>mdi-check</v-icon> แนบไฟล์แล้ว
                  </v-chip>
                </div>
              </v-stepper-step>
              <v-stepper-content step="19">
                <v-card class="pa-4">
                  <v-row>
                    <v-col cols="12">
                      <v-alert type="warning" outlined>
                        <h3>
                          กรุณาอัปโหลดแบบคำร้องขอย้ายที่ลงนามเรียบร้อยแล้ว
                          รายการทั้งหมดถึงจะสมบูรณ์
                        </h3>
                        <p>รองรับไฟล์ PDF, JPG, PNG ขนาดไม่เกิน 10 MB</p>
                      </v-alert>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-btn
                        x-large
                        color="info"
                        dark
                        class="ma-2"
                        @click="openPrintDialog()"
                      >
                        <v-icon left>mdi-printer</v-icon>
                        <span>พิมพ์แบบแสดงความประสงค์ขอย้าย</span>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-file-input
                        v-model="fileAttachment"
                        label="เลือกไฟล์แบบคำร้อง"
                        outlined
                        accept=".pdf,.jpg,.jpeg,.png"
                        prepend-icon="mdi-paperclip"
                        show-size
                      ></v-file-input>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      v-if="transference_manages.manage_file_attachment"
                    >
                      <v-alert type="success" outlined>
                        <v-icon left>mdi-file-check</v-icon>
                        ไฟล์ที่แนบ:
                        {{ transference_manages.manage_file_attachment }}<br />
                        วันที่แนบ:
                        {{ transference_manages.manage_file_attachment_date }}
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-card>
                <v-btn
                  @click="uploadFileAttachment()"
                  color="primary"
                  :loading="uploading"
                  :disabled="!fileAttachment"
                >
                  <v-icon left>mdi-upload</v-icon> อัปโหลดไฟล์
                </v-btn>
                <v-btn
                  text
                  @click="skipFileUpload()"
                  v-if="transference_manages.manage_file_attachment"
                  >ข้ามขั้นตอนนี้ (แนบไฟล์แล้ว)</v-btn
                >
              </v-stepper-content>

              <!-- STEP 20: แสดงไฟล์แนบ และ แบบยื่น -->
              <v-stepper-step :complete="steps > 20" step="20">
                <div>
                  ตรวจสอบไฟล์แนบและแบบคำร้อง
                </div>
              </v-stepper-step>
              <v-stepper-content step="20">
                <v-card class="pa-4 mb-4">
                  <v-row>
                    <v-col cols="12" md="6">
                      <h3>แบบแสดงความประสงค์ขอย้าย</h3>
                      <iframe
                        style="width:100%; height: 400px; border: 1px solid #ddd; border-radius: 8px;"
                        :src="
                          '#/user/print_info_manage/?manage_id_ref=' +
                            manage_id_ref
                        "
                      ></iframe>
                      <div class="text-center mt-3">
                        <v-btn
                          outlined
                          color="primary"
                          target="_blank"
                          :href="
                            '#/user/print_info_manage/?manage_id_ref=' +
                              manage_id_ref
                          "
                        >
                          <v-icon left>mdi-open-in-new</v-icon>
                          เปิดดูแบบฟอร์มเต็มจอ
                        </v-btn>
                      </div>
                    </v-col>

                    <v-col cols="12" md="6">
                      <h3>ไฟล์แนบแบบคำร้อง</h3>
                      <div v-if="transference_manages.manage_file_attachment">
                        <p class="mb-1">
                          <strong>ไฟล์ที่แนบ:</strong>
                          {{ transference_manages.manage_file_attachment
                          }}<br />
                          <strong>วันที่แนบ:</strong>
                          {{ transference_manages.manage_file_attachment_date }}
                        </p>
                        <iframe
                          style="width:100%; height: 400px; border: 1px solid #ddd; border-radius: 8px;"
                          :src="
                            '/uploads/transference_manage/' +
                              transference_manages.manage_file_attachment
                          "
                        ></iframe>
                        <div class="text-center mt-3">
                          <v-btn
                            outlined
                            color="info"
                            target="_blank"
                            :href="
                              '/uploads/transference_manage/' +
                                transference_manages.manage_file_attachment
                            "
                          >
                            <v-icon left>mdi-file-pdf-box</v-icon>
                            เปิดดูไฟล์แนบเต็มจอ
                          </v-btn>
                        </div>
                      </div>
                      <div v-else>
                        <v-alert type="warning" outlined class="mt-4">
                          <v-icon left>mdi-alert</v-icon>
                          ยังไม่มีไฟล์แนบแบบคำร้อง
                        </v-alert>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>

                <v-btn
                  @click="submitTransference()"
                  color="success"
                  x-large
                  :loading="submitting"
                  ><v-icon left>mdi-check-circle</v-icon>
                  ยืนยันการยื่นคำร้องขอย้าย</v-btn
                >
                <v-btn text large @click="canceltransference((step = 18))"
                  >ย้อนกลับ</v-btn
                >
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </base-material-card>

        <!-- ══════════════════════════════════════ -->
        <!-- Dialog: เลือกวิทยาลัย (เดิม)          -->
        <!-- ══════════════════════════════════════ -->
        <v-layout>
          <v-dialog
            v-model="addtransference_manage_locationdialog"
            persistent
            max-width="60%"
          >
            <v-card class="mx-auto pa-5">
              <base-material-card
                icon="mdi-account-multiple"
                title="เลือกวิทยาลัย"
                class="px-5 py-3"
              >
                รหัสรายการอ้างอิง {{ manage_id_ref }}
              </base-material-card>
              <v-card-text>
                <v-form
                  ref="addtransference_manage_locationform"
                  lazy-validation
                >
                  <v-container grid-list-md
                    ><v-layout wrap>
                      <v-flex md2
                        ><v-select
                          v-model="
                            addtransference_manage_location.manage_location_sequence_n
                          "
                          :items="order_need"
                          outlined
                          label="ลำดับที่ :"
                        ></v-select
                      ></v-flex>
                      <v-flex md10
                        ><v-autocomplete
                          v-model="
                            addtransference_manage_location.manage_location_college_code
                          "
                          :items="colleges"
                          item-text="college_name"
                          item-value="college_code"
                          outlined
                          label="สังกัด :"
                          prepend-icon="mdi-flag-letiant"
                          :rules="[v => !!v || '']"
                        ></v-autocomplete
                      ></v-flex> </v-layout
                  ></v-container>
                  <small>* จำเป็น</small>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="warning"
                  large
                  @click.stop="addtransference_manage_locationdialog = false"
                  ><v-icon dark>mdi-close</v-icon> ยกเลิก</v-btn
                >
                <v-btn
                  large
                  color="success"
                  @click.stop="addtransference_manage_locationSubmit()"
                  ><v-icon dark>mdi-content-save</v-icon
                  >&nbsp;&nbsp;บันทึก</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <!-- ══════════════════════════════════════ -->
        <!-- Dialog: ลบรายการ (เดิม)               -->
        <!-- ══════════════════════════════════════ -->
        <v-layout>
          <v-dialog
            v-model="delettransference_manage_locationdialog"
            persistent
            max-width="40%"
          >
            <v-card class="mx-auto pa-5">
              <base-material-card
                color="error"
                icon="mdi-delete"
                title="ลบรายการ"
                class="px-5 py-3 text_google"
              ></base-material-card>
              <v-card-text class="text_google"
                ><v-card
                  ><v-card-text>
                    <v-form
                      ref="deletetransference_manage_locationform"
                      lazy-validation
                    >
                      <v-container grid-list-md
                        ><v-layout wrap
                          ><v-flex xs12
                            >ยืนยันการลบ
                            <span>{{
                              edittransference_manage_location.college_name
                            }}</span></v-flex
                          ></v-layout
                        ></v-container
                      >
                    </v-form>
                  </v-card-text></v-card
                ></v-card-text
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  large
                  @click.stop="delettransference_manage_locationdialog = false"
                  ><v-icon dark>mdi-close</v-icon>ยกเลิก</v-btn
                >
                <v-btn
                  large
                  color="red darken-3"
                  @click.stop="deletetransference_manage_locationSubmit()"
                  dark
                  ><v-icon dark>mdi-delete</v-icon>&nbsp;ลบ</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <!-- ══════════════════════════════════════════════ -->
        <!-- Dialog: ยกเลิกรายการด้วยตนเอง [ข้อ 3] ★ ใหม่ ★ -->
        <!-- ══════════════════════════════════════════════ -->
        <v-layout>
          <v-dialog v-model="cancelSelfDialog" persistent max-width="50%">
            <v-card class="mx-auto pa-5">
              <base-material-card
                color="error"
                icon="mdi-cancel"
                title="ยกเลิกรายการย้ายด้วยตนเอง"
                class="px-5 py-3 text_google"
              ></base-material-card>
              <v-card-text>
                <v-alert type="warning" outlined prominent class="mb-4">
                  <h3>คำเตือน</h3>
                  <p>
                    เมื่อยกเลิกแล้ว ข้อมูลจะไม่สามารถกู้คืนได้
                    กรุณาตรวจสอบให้แน่ใจก่อนยืนยัน
                  </p>
                </v-alert>
                <v-form ref="cancelForm">
                  <v-textarea
                    v-model="cancelReason"
                    outlined
                    label="เหตุผลในการยกเลิก *"
                    :rules="[v => !!v || 'กรุณาระบุเหตุผลในการยกเลิก']"
                    rows="3"
                  ></v-textarea>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn large @click="cancelSelfDialog = false"
                  ><v-icon dark>mdi-close</v-icon> ปิด</v-btn
                >
                <v-btn
                  large
                  color="red darken-3"
                  dark
                  @click="confirmCancelSelf()"
                  :loading="cancelLoading"
                  ><v-icon dark>mdi-cancel</v-icon> ยืนยันยกเลิกรายการ</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <!-- ══════════════════════════════════════════════════════ -->
        <!-- Dialog: พิมพ์แบบแสดงความประสงค์ขอย้าย [ข้อ 7] ★ ใหม่ ★ -->
        <!-- ══════════════════════════════════════════════════════ -->
        <v-dialog v-model="printDialog" width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">แบบแสดงความประสงค์ขอย้าย</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="printDialog = false"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-card-title>
            <v-card-text>
              <iframe
                style="width:100%; height: 600px; border: none;"
                :src="
                  '#/user/print_info_manage/?manage_id_ref=' + manage_id_ref
                "
              ></iframe>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="printDialog = false">ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- ══════════════════════════════════════ -->
        <!-- Dialog: ตัวอย่าง Preview (เดิม)        -->
        <!-- ══════════════════════════════════════ -->
        <v-dialog v-model="previewReport" width="80%">
          <v-card>
            <v-card-title>
              <span>ตัวอย่างแบบแสดงความประสงค์ขอย้าย</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="previewReport = false"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-card-title>
            <iframe
              style="width:100%; height: 600px;"
              :src="
                '#/user/print_info_manage_preview/?manage_id_ref=' +
                  manage_id_ref
              "
            ></iframe>
          </v-card>
        </v-dialog>

        <!-- ══════════════════════════════════════ -->
        <!-- Dialog: File Attachment       -->
        <!-- ══════════════════════════════════════ -->

        <v-dialog v-model="fileAttachmentDialog" width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ไฟล์แนบ</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="fileAttachmentDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <iframe
                style="width:100%; height: 600px; border: none;"
                :src="'/uploads/transference_manage/' + fileAttachmentUrl"
              ></iframe>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <!-- Snackbar -->
    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "HrvecTransferencePersonnel",

  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      localTime: "",
      isHidden: false,
      timestamp: "",
      colleges: [],
      personnel_search: {},
      show_personnel: [],
      transference_manage_locations: [],
      search: "",
      addtransference_manage_locationdialog: false,
      delettransference_manage_locationdialog: false,
      Search_Personneldialog: false,
      confirm_dialog: false,
      user: {},
      transference_manage: [],
      transference_manages: [],
      addtransference_manage: {
        manage_on_study_leave: "no_leave",
        manage_disciplinary: "no_discip",
        manage_license: "no_license",
        manage_case_move: "normal",
        manage_move_if: "suspend",
        manage_switch_position: "-",
        manage_service_status: "not_service"
      },
      addtransference_manage_location: {},
      edittransference_manage_location: [],
      provinces: [],
      provices_sh: [],
      prefectures: [],
      personnel_educations: [],
      personnel_education_check: [],
      district: [],
      district_post_s: [],
      snackbar: { show: false, color: "", timeout: 5000, icon: "", text: "" },
      order_need: [1, 2, 3],
      header_trans: [
        { text: "ลำดับ", align: "center", value: "manage_location_sequence_n" },
        {
          text: "รหัสอ้างอิง",
          align: "center",
          value: "manage_location_id_ref"
        },
        { text: "ตำแหน่ง", align: "center", value: "manage_location_position" },
        { text: "วิทยาลัย", align: "center", value: "college_name" },
        { text: "ยกเลิก", align: "center", value: "action" }
      ],
      header_work: [
        { text: "ลำดับ", align: "center", value: "index" },
        { text: "วันเดือนปี", align: "center", value: "date_begin" },
        { text: "ตำแหน่ง/ระดับ", align: "center", value: "position_s" },
        { text: "สังกัด", align: "center", value: "college_code" },
        { text: "หมายเหตุ", align: "center", value: "action" }
      ],
      isEditing: null,
      show1: false,
      pagination: {},
      personnel_marriages: [],
      rowsperpage: [25, 50, 100, { text: "All", value: -1 }],
      personnel_temporarys: [],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      modal_1: false,
      modal_2: false,
      modal_3: false,
      modal_4: false,
      menu2: false,
      periods: [],
      period_enable: "1",
      personnel_work_history: [],
      personnel_work_history_check: [],
      transference_manage_location_update: {},
      manage_reason_2_years: [
        { text: "เสียชีวิต", value: "เสียชีวิต" },
        ...Array.from({ length: 108 }, (_, i) => ({
          text: String(30 + i),
          value: String(30 + i)
        }))
      ],
      steps: 1,
      previewReport: false,

      // ╔══════════════════════════════════════════╗
      // ║ ตัวแปรใหม่ที่เพิ่มเข้ามา                 ║
      // ╚══════════════════════════════════════════╝

      // [ข้อ 2] แนบไฟล์
      fileAttachment: null,
      uploading: false,
      submitting: false,

      // [ข้อ 3] ยกเลิกด้วยตนเอง
      cancelSelfDialog: false,
      cancelReason: "",
      cancelLoading: false,
      isPeriodOpen: true,

      // [ข้อ 7] Dialog พิมพ์
      printDialog: false,
      fileAttachmentDialog: false,
      fileAttachmentUrl: ""
    };
  },

  async mounted() {
    let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;

    let result_provice = await this.$http.post("province_sh.php", {
      ApiKey: this.ApiKey
    });
    this.provices_sh = result_provice.data;

    let result = await this.$http.post("college.php", { ApiKey: this.ApiKey });
    this.colleges = result.data;

    let result_user = await this.$http.post("personnel_temporary.php", {
      ApiKey: this.ApiKey,
      id_card: userSession.id_card
    });
    this.user = result_user.data;

    await this.periodQuery();
    await this.transference_manageAll();
    await this.transference_manage_locationQueryAll();
    await this.personnel_educationsQueryAll();
    await this.personnel_educations_checkQueryAll();
    await this.personnel_work_historyQueryAll();
    await this.personnel_work_historyCheck();
    await this.personnel_temporarysQueryAll();
    this.showLocaleTime();
  },

  methods: {
    previewFile(url) {
      this.fileAttachmentDialog = true;
      this.fileAttachmentUrl = url;
    },

    async submitTransference() {
      this.submitting = true;
      try {
        // อัปเดตสถานะเป็น 'Confirm' หรือสถานะที่ Backend ของคุณต้องการสำหรับขั้นตอนสุดท้าย
        let data = {
          ApiKey: this.ApiKey,
          manage_id_ref: this.manage_id_ref,
          manage_id_card: this.user.id_card,
          manage_status_save: "Confirm" // หรือสถานะที่เหมาะสม
        };

        let result = await this.$http.post(
          "transference_manage.update.php",
          data
        );
        console.log("Submit Result: ", result);

        if (result.data.status == true) {
          await this.saveLog(
            "submit_final",
            20,
            "ยืนยันการยื่นคำร้องขอย้ายเสร็จสมบูรณ์"
          );

          Swal.fire({
            icon: "success",
            title: "ยื่นคำร้องขอย้ายเสร็จสมบูรณ์!",
            showConfirmButton: true
          }).then(() => {
            // โหลดข้อมูลใหม่เพื่อรีเซ็ตหน้าจอ หรือคุณสามารถใช้ this.$router.push('/Dashboard')
            this.transference_manageAll();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาดในการยืนยันข้อมูล"
          });
        }
      } catch (e) {
        console.error("Submit Error: ", e);
        Swal.fire({ icon: "error", title: "ระบบขัดข้อง" });
      }
      this.submitting = false;
    },
    // ══════════════════════════════════════════════
    // [ข้อ 4] บันทึก Log ทุกครั้งที่ทำรายการ
    // ══════════════════════════════════════════════
    async saveLog(action, step, detail) {
      try {
        await this.$http.post("transference_manage_log.insert.php", {
          ApiKey: this.ApiKey,
          log_manage_id_ref: this.manage_id_ref,
          log_id_card: this.user.id_card,
          log_action: action,
          log_step: String(step),
          log_detail: detail,
          log_ip_address: "",
          log_user_agent: navigator.userAgent
        });
      } catch (e) {
        console.error("Log save error:", e);
      }
    },

    // ══════════════════════════════════════════════
    // [ข้อ 5] คำนวณจำนวนนักเรียนรวมอัตโนมัติ
    // เรียกทุกครั้งที่กรอก ปวช. ปวส. ระยะสั้น
    // ══════════════════════════════════════════════
    calculateTotalStudents() {
      const vc = parseInt(this.transference_manages.manage_std_vc) || 0;
      const hvc = parseInt(this.transference_manages.manage_std_hvc) || 0;
      const sc = parseInt(this.transference_manages.manage_std_sc) || 0;
      this.transference_manages.manage_std_all = vc + hvc + sc;
    },

    // ══════════════════════════════════════════════
    // [ข้อ 6] Validate ต้องเลือกหน่วยงานอย่างน้อย 1 แห่ง
    // ══════════════════════════════════════════════
    async validateAndSaveStep16() {
      if (this.transference_manage_locations.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "กรุณาเลือกหน่วยงานที่ประสงค์ขอย้ายอย่างน้อย 1 แห่ง",
          showConfirmButton: true
        });
        return;
      }
      await this.updatetransference_manageSubmit(16);
    },

    // ══════════════════════════════════════════════
    // [ข้อ 2] อัปโหลดไฟล์แบบคำร้อง
    // ══════════════════════════════════════════════
    async uploadFileAttachment() {
      if (!this.fileAttachment) {
        Swal.fire({ icon: "warning", title: "กรุณาเลือกไฟล์" });
        return;
      }
      if (this.fileAttachment.size > 10 * 1024 * 1024) {
        Swal.fire({
          icon: "warning",
          title: "ไฟล์มีขนาดใหญ่เกินไป (สูงสุด 10MB)"
        });
        return;
      }
      this.uploading = true;
      try {
        let formData = new FormData();
        formData.append("ApiKey", this.ApiKey);
        formData.append("manage_id_ref", this.manage_id_ref);
        formData.append("manage_id_card", this.user.id_card);
        formData.append("manage_file", this.fileAttachment);
        let result = await this.$http.post(
          "transference_manage_file_upload.php",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );
        if (result.data.status == true) {
          await this.saveLog(
            "upload_file",
            19,
            "อัปโหลดไฟล์: " + result.data.filename
          );
          Swal.fire({
            icon: "success",
            title: "อัปโหลดไฟล์สำเร็จ",
            showConfirmButton: false,
            timer: 1500
          });
          await this.transference_manageAll();
        } else {
          Swal.fire({
            icon: "error",
            title: result.data.message || "อัปโหลดไฟล์ผิดพลาด"
          });
        }
      } catch (e) {
        Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาดในการอัปโหลด" });
      }
      this.uploading = false;
    },

    skipFileUpload() {
      this.steps = 20;
    },

    // ══════════════════════════════════════════════
    // [ข้อ 3] ยกเลิกรายการด้วยตนเอง
    // ══════════════════════════════════════════════
    showCancelDialog() {
      this.cancelReason = "";
      this.cancelSelfDialog = true;
    },

    async confirmCancelSelf() {
      if (!this.$refs.cancelForm.validate()) return;
      this.cancelLoading = true;
      try {
        let result = await this.$http.post("transference_manage_cancel.php", {
          ApiKey: this.ApiKey,
          manage_id_ref: this.manage_id_ref,
          manage_id_card: this.user.id_card,
          manage_cancel_reason: this.cancelReason,
          log_ip_address: "",
          log_user_agent: navigator.userAgent
        });
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ยกเลิกรายการเรียบร้อยแล้ว",
            text: "ท่านสามารถทำรายการใหม่ได้"
          }).then(() => {
            this.cancelSelfDialog = false;
            this.transference_manageAll();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: result.data.message || "ไม่สามารถยกเลิกรายการได้"
          });
        }
      } catch (e) {
        Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาด" });
      }
      this.cancelLoading = false;
    },

    // ══════════════════════════════════════════════
    // [ข้อ 3] ตรวจสอบว่าระบบยังเปิดอยู่
    // ══════════════════════════════════════════════
    async checkPeriodOpen() {
      try {
        let result = await this.$http.post("period.php", {
          ApiKey: this.ApiKey,
          period_enable: "OK",
          period_type: "manage"
        });
        this.isPeriodOpen = result.data && result.data.period_enable === "1";
      } catch (e) {
        this.isPeriodOpen = false;
      }
    },

    // ══════════════════════════════════════════════
    // [ข้อ 7] เปิด Dialog พิมพ์
    // ══════════════════════════════════════════════
    openPrintDialog() {
      this.printDialog = true;
    },

    // ══════════════════════════════════════════════
    // Methods เดิมที่มีอยู่ (ปรับปรุงบางส่วน)
    // ══════════════════════════════════════════════
    async previewReportShow() {
      this.previewReport = true;
    },

    clearCasemove() {
      this.transference_manages.manage_reason_1_sp = false;
      this.transference_manages.manage_reason_2_sp = false;
      this.transference_manages.manage_reason_3_sp = false;
    },

    clear_gov_service() {
      // เคลียร์ข้อมูลเมื่อเลือกระงับการย้าย
      this.transference_manages.manage_move_if_detail = "";
    },

    showLocaleTime() {
      var time = this;
      setInterval(function() {
        time.localTime = new Date().toLocaleTimeString();
      }, 1000);
    },

    async periodQuery() {
      let result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable: "OK",
        period_type: this.user_status_type
      });
      this.periods = result_period.data;
      if (
        this.periods.period_enable === "1" &&
        this.periods.period_type === "manage"
      ) {
        // OK
      } else {
        this.$router.push("/UserProfile");
      }
      if (this.get_gov_Age_year >= 2) {
        // OK
      } else {
        this.$router.push("/UserProfile");
        Swal.fire({
          icon: "error",
          title:
            "ผู้ขอย้ายดำรงตำแหน่งในสถานศึกษาปัจจุบันไม่น้อยกว่า 24 เดือน โดยให้นับระยะเวลาการดำรงตำแหน่งถึงวันที่ 30 กันยายน ของปีที่ยื่นคำร้องขอย้ายประจำปี",
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(async result => {
          if (result.isConfirmed) {
            this.$router.push("/UserProfile");
          }
        });
      }
    },

    async personnel_work_historyQueryAll() {
      this.loading = true;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      let result = await this.$http
        .post("personnel_work_history.php", {
          ApiKey: this.ApiKey,
          id_card: userSession.id_card
        })
        .finally(() => (this.loading = false));
      this.personnel_work_history = result.data;
    },

    async personnel_work_historyCheck() {
      this.loading = true;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      let result = await this.$http
        .post("personnel_work_history.php", {
          ApiKey: this.ApiKey,
          id_card: userSession.id_card,
          count_check: "Ok"
        })
        .finally(() => (this.loading = false));
      this.personnel_work_history_check = result.data;
    },

    async personnel_educationsQueryAll() {
      this.loading = true;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      let result = await this.$http
        .post("personnel_education.php", {
          ApiKey: this.ApiKey,
          id_card: userSession.id_card
        })
        .finally(() => (this.loading = false));
      this.personnel_educations = result.data;
    },

    async personnel_educations_checkQueryAll() {
      this.loading = true;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      let result = await this.$http
        .post("personnel_education.check.php", {
          ApiKey: this.ApiKey,
          id_card: userSession.id_card
        })
        .finally(() => (this.loading = false));
      this.personnel_education_check = result.data;
    },

    async OnEnter() {
      let data;
      if (this.addtransference_manage.manage_switch_position)
        data = this.addtransference_manage.manage_switch_position;
      if (this.transference_manages.manage_switch_position)
        data = this.transference_manages.manage_switch_position;
      let result = await this.$http
        .post("personnel_temporary.php", { ApiKey: this.ApiKey, id_card: data })
        .finally(() => (this.loading = false));
      this.personnel_temporarys = result.data;
    },

    // ══════════════════════════════════════════════════════
    // transference_manageAll: ปรับปรุงรองรับ step 19, 20
    // ══════════════════════════════════════════════════════
    async transference_manageAll() {
      this.loading = true;
      let result = await this.$http
        .post("transference_manage.php", {
          ApiKey: this.ApiKey,
          manage_id_ref: this.manage_id_ref
        })
        .finally(() => (this.loading = false));
      this.transference_manages = result.data;

      let stepsep = this.transference_manages.manage_status_save;
      if (stepsep == "Save") {
        // [ข้อ 2] ถ้ายังไม่ได้แนบไฟล์ ไป step 19 ถ้าแนบแล้ว ไป step 20
        if (!this.transference_manages.manage_file_attachment) {
          this.steps = 19;
        } else {
          this.steps = 20;
        }
      } else if (stepsep == "Cancel") {
        this.steps = 1;
      } else if (stepsep >= 1) {
        this.steps = parseInt(stepsep) + 1;
      } else {
        this.steps = 1;
      }

      // [ข้อ 3] ตรวจสอบระบบเปิด-ปิด
      this.checkPeriodOpen();
    },

    async personnel_temporarysQueryAll() {
      let result = await this.$http.post("personnel_temporary.php", {
        ApiKey: this.ApiKey,
        id_card: this.transference_manages.manage_switch_position
      });
      this.personnel_temporarys = result.data;
    },

    async transference_manage_locationQueryAll() {
      let result = await this.$http.post("transference_manage_location.php", {
        ApiKey: this.ApiKey,
        manage_location_id_ref: this.manage_id_ref
      });
      this.transference_manage_locations = result.data;
    },

    async addtransference_manage_locationdialogsubmit() {
      this.addtransference_manage_location = {};
      this.addtransference_manage_locationdialog = true;
    },

    async addtransference_manage_locationSubmit() {
      if (this.$refs.addtransference_manage_locationform.validate()) {
        this.addtransference_manage_location.ApiKey = this.ApiKey;
        this.addtransference_manage_location.manage_location_id_ref = this.manage_id_ref;
        this.addtransference_manage_location.manage_location_id_card = this.user.id_card;
        this.addtransference_manage_location.manage_location_position = this.user.position_name;
        let result = await this.$http.post(
          "transference_manage_location.insert.php",
          this.addtransference_manage_location
        );
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manage_locationQueryAll();
        } else {
          this.snackbar.icon = "mdi-close-network";
          this.snackbar.color = "red";
          this.snackbar.text =
            "บันทึกข้อมูลผิดพลาด รายการลำดับ หรือ ชื่อหน่วยงานแหน่งใหม่ซ้ำ";
          this.snackbar.show = true;
        }
        this.addtransference_manage_locationdialog = false;
      }
    },

    async transference_manage_locationDelete(manage_location_id_tfl) {
      let result = await this.$http.post("transference_manage_location.php", {
        ApiKey: this.ApiKey,
        manage_location_id_tfl: manage_location_id_tfl
      });
      this.edittransference_manage_location = result.data;
      this.delettransference_manage_locationdialog = true;
    },

    async deletetransference_manage_locationSubmit() {
      if (this.$refs.deletetransference_manage_locationform.validate()) {
        this.edittransference_manage_location.ApiKey = this.ApiKey;
        let result = await this.$http.post(
          "transference_manage_location.delete.php",
          this.edittransference_manage_location
        );
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการลบข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manage_locationQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการลบผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.delettransference_manage_locationdialog = false;
      }
    },

    // ═══════════════════════════════════════════════════════
    // addtransference_manageSubmit: สร้างรายการใหม่
    // [ข้อ 4] เพิ่ม saveLog()
    // ═══════════════════════════════════════════════════════
    async addtransference_manageSubmit(steps) {
      Swal.fire({
        title: "ประสงค์ทำรายการยืนย้าย",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          this.addtransference_manage.ApiKey = this.ApiKey;
          this.addtransference_manage.manage_id_ref = this.manage_id_ref;
          this.addtransference_manage.manage_time_s = this.periods.period_times;
          this.addtransference_manage.manage_year_s = this.periods.period_year;
          this.addtransference_manage.manage_year_age = String(this.get_Age);
          this.addtransference_manage.manage_year_budget = this.periods.period_year;
          this.addtransference_manage.manage_id_card = this.user.id_card;
          this.addtransference_manage.manage_date_time = this.date_today;
          this.addtransference_manage.manage_age_app_time = String(
            this.get_Appoint_Age
          );
          this.addtransference_manage.manage_age_time = String(
            this.get_gov_Age
          );
          this.addtransference_manage.manage_college_code_now = this.user.college_code;
          this.addtransference_manage.manage_status_save = steps;

          let result = await this.$http.post(
            "transference_manage.insert.php",
            this.addtransference_manage
          );
          if (result.data.status == true) {
            await this.saveLog("insert", steps, "สร้างรายการย้ายใหม่"); // [ข้อ 4]
            Swal.fire({
              icon: "success",
              title: "ดำเนินการข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            this.transference_manageAll();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },

    // ═══════════════════════════════════════════════════════════════
    // updatetransference_manageSubmit: บันทึกข้อมูลแต่ละ step
    // [ข้อ 1] เพิ่ม validation ทุก step
    // [ข้อ 4] เพิ่ม saveLog()
    // [ข้อ 5] คำนวณนักเรียนรวมก่อนบันทึก step 13
    // ═══════════════════════════════════════════════════════════════
    async updatetransference_manageSubmit(step) {
      // ── [ข้อ 1] Validation ทุกขั้นตอน ──
      if (step == 2 && !this.transference_manages.manage_knowledge) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกข้อมูลความรู้ความสามารถ"
        });
        return;
      }
      if (step == 3 && !this.transference_manages.manage_experience) {
        Swal.fire({ icon: "warning", title: "กรุณากรอกข้อมูลประสบการณ์" });
        return;
      }
      if (step == 5 && !this.transference_manages.manage_address_now) {
        Swal.fire({ icon: "warning", title: "กรุณากรอกที่อยู่ปัจจุบัน" });
        return;
      }
      if (step == 6 && !this.transference_manages.manage_after_move) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกที่อยู่เมื่อได้ย้ายแล้ว"
        });
        return;
      }
      if (step == 10 && !this.transference_manages.manage_performance) {
        Swal.fire({ icon: "warning", title: "กรุณากรอกผลการปฏิบัติงาน" });
        return;
      }

      // ── [ข้อ 5] คำนวณนักเรียนรวมอัตโนมัติ ──
      if (step == 13) {
        this.calculateTotalStudents();
      }

      // ── ตั้งค่าข้อมูลก่อนบันทึก ──
      this.transference_manages.ApiKey = this.ApiKey;
      this.transference_manages.manage_age_app_time = String(
        this.get_Appoint_Age
      );
      this.transference_manages.manage_year_age = String(this.get_Age);
      this.transference_manages.manage_age_time = String(this.get_gov_Age);
      this.transference_manages.manage_status_save = step;

      // ── Reset checkbox ที่ไม่ได้เลือก ──
      [
        "manage_reason_1",
        "manage_reason_2",
        "manage_reason_3",
        "manage_reason_4",
        "manage_reason_1_sp",
        "manage_reason_2_sp",
        "manage_reason_3_sp",
        "manage_evidence_info_1",
        "manage_evidence_info_2",
        "manage_evidence_info_3",
        "manage_evidence_info_4",
        "manage_evidence_info_5",
        "manage_evidence_info_6",
        "manage_evidence_info_7",
        "manage_evidence_info_8"
      ].forEach(field => {
        if (this.transference_manages[field] != 1)
          this.transference_manages[field] = 0;
      });

      // ── Step 18: ขั้นตอนสุดท้าย ยืนยันข้อมูล ──
      if (step == 18) {
        this.transference_manages.manage_status_save = "Save";
        this.transference_manage_location_update.ApiKey = this.ApiKey;
        this.transference_manage_location_update.manage_location_id_ref = this.transference_manages.manage_id_ref;
        this.transference_manage_location_update.manage_location_status_confirm =
          "Save";

        Swal.fire({
          title:
            "ขั้นตอนนี้เป็นขั้นตอนสุดท้าย เมื่อท่านกดยืนยันจะไม่สามารถแก้ไขข้อมูลได้แล้ว กรุณาตรวจสอบให้ถูกต้อง",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก"
        }).then(async result => {
          if (result.isConfirmed) {
            let result = await this.$http.post(
              "transference_manage.update.php",
              this.transference_manages
            );
            let result_up = await this.$http.post(
              "transference_manage_location.update.php",
              this.transference_manage_location_update
            );
            if (result.data.status == true || result_up.data.status == true) {
              await this.saveLog("save_final", step, "ยืนยันรายการย้ายสำเร็จ"); // [ข้อ 4]
              this.transference_manageAll();
              Swal.fire({
                icon: "success",
                title: "ดำเนินการข้อมูลเรียบร้อย",
                showConfirmButton: false,
                timer: 1500
              });
            } else {
              Swal.fire({
                icon: "warning",
                title: "ดำเนินการผิดพลาด",
                showConfirmButton: false,
                timer: 1500
              });
            }
          }
        });
      } else {
        // ── Step อื่นๆ ──
        let result = await this.$http.post(
          "transference_manage.update.php",
          this.transference_manages
        );
        if (result.data.status == true) {
          await this.saveLog("update", step, "บันทึกข้อมูลขั้นตอนที่ " + step); // [ข้อ 4]
          this.transference_manageAll();
          Swal.fire({
            icon: "success",
            title: "ดำเนินการข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    },

    // ═══════════════════════════════════════════════════
    // canceltransference: ยกเลิก/ย้อนกลับ step (เดิม)
    // ═══════════════════════════════════════════════════
    async canceltransference(step) {
      if (step == 2) {
        this.transference_manages.ApiKey = this.ApiKey;
        this.transference_manage_location_update.ApiKey = this.ApiKey;
        this.transference_manage_location_update.manage_location_id_ref = this.transference_manages.manage_id_ref;

        Swal.fire({
          title: "ต้องการยกเลิกรายการยืนย้ายครั้งนี้",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก"
        }).then(async result => {
          if (result.isConfirmed) {
            let result = await this.$http.post(
              "transference_manage.delete.php",
              this.transference_manages
            );
            let result_up = await this.$http.post(
              "transference_manage_location.delete.cancel.php",
              this.transference_manage_location_update
            );
            if (result.data.status == true || result_up.data.status == true) {
              await this.saveLog("cancel", step, "ยกเลิกรายการย้ายทั้งหมด"); // [ข้อ 4]
              Swal.fire({
                icon: "success",
                title: "ดำเนินการข้อมูลเรียบร้อย",
                showConfirmButton: false,
                timer: 1500
              });
              this.transference_manageAll();
            } else {
              Swal.fire({
                icon: "warning",
                title: "ดำเนินการผิดพลาด",
                showConfirmButton: false,
                timer: 1500
              });
            }
          }
        });
      } else {
        this.transference_manages.ApiKey = this.ApiKey;
        this.transference_manages.manage_age_app_time = String(
          this.get_Appoint_Age
        );
        this.transference_manages.manage_year_age = String(this.get_Age);
        this.transference_manages.manage_age_time = String(this.get_gov_Age);
        this.transference_manages.manage_status_save = step;
        let result = await this.$http.post(
          "transference_manage.update.php",
          this.transference_manages
        );
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manageAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    },

    // Helper สำหรับคำนวณอายุ (ใช้ร่วมกัน)
    _calcAge(today, DOB) {
      let result = {
        years: 0,
        months: 0,
        days: 0,
        toString() {
          return (
            (this.years ? this.years + " ปี " : "") +
            (this.months ? this.months + " เดือน " : "") +
            (this.days ? this.days + " วัน" : "")
          );
        }
      };

      // Prevent crashing if an Invalid Date sneaks through
      if (!today || !DOB || isNaN(today) || isNaN(DOB)) return result;

      result.months =
        today.getFullYear() * 12 +
        (today.getMonth() + 1) -
        (DOB.getFullYear() * 12 + (DOB.getMonth() + 1));

      if (0 > (result.days = today.getDate() - DOB.getDate())) {
        var y = today.getFullYear(),
          m = today.getMonth();
        m = --m < 0 ? 11 : m;
        result.days +=
          [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m] +
          (1 == m && y % 4 == 0 && (y % 100 > 0 || y % 400 == 0) ? 1 : 0);
        --result.months;
      }
      result.years = Math.floor(result.months / 12);
      result.months = result.months % 12;
      return result;
    }
  },

  computed: {
    timenow() {
      const d = new Date();
      return d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    },
    user_status_type() {
      let us = this.user.user_status;
      if (us == "teacher") return "teacher";
      if (us == "director" || us == "se_director") return "manage";
      return "manage";
    },
    month_now() {
      return new Date().getMonth() + 1;
    },
    manage_id_ref() {
      return (
        "M" +
        this.periods.period_times +
        "" +
        parseInt(this.periods.period_year) +
        "" +
        this.user.id_card
      );
    },
    marital_status() {
      const m = this.user.marital_status;
      const map = {
        single: "โสด",
        married: "สมรส",
        widow: "หม้าย",
        divorce: "หย่า",
        separate: "แยกกันอยู่"
      };
      return map[m] || "";
    },
    date_today() {
      let t = new Date();
      return (
        String(t.getDate()).padStart(2, "0") +
        "/" +
        String(t.getMonth() + 1).padStart(2, "0") +
        "/" +
        (t.getFullYear() + 543)
      );
    },
    date_today_cal() {
      let t = new Date();
      return (
        t.getFullYear() +
        "-" +
        String(t.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(t.getDate()).padStart(2, "0")
      );
    },
    dmy_app_cal() {
      return (
        this.user.appoin_month +
        "/" +
        this.user.appoin_day +
        "/" +
        (this.user.appoin_year - 543)
      );
    },
    date_appoin_ch() {
      let monthNames = [
        "",
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ];
      return (
        this.user.appoin_day +
        " " +
        monthNames[parseInt(this.user.appoin_month)] +
        " " +
        parseInt(this.user.appoin_year)
      );
    },
    date_month_cal() {
      if (!this.periods || !this.periods.period_cal_end) return null;
      return new Date(this.periods.period_cal_end);
    },
    get_Age() {
      let today = new Date(this.date_today_cal);
      let DOB = new Date(
        parseInt(this.user.brith_year) -
          543 +
          "-" +
          this.user.brith_month +
          "-" +
          this.user.brith_day
      );

      // MUST have "this."
      return this._calcAge(today, DOB);
    },

    get_Appoint_Age() {
      let today = new Date(this.date_month_cal);
      let DOB = new Date(this.user.date_app_now);

      // MUST have "this."
      return this._calcAge(today, DOB);
    },

    get_gov_Age() {
      let today = new Date(this.date_today_cal);
      let DOB = new Date(
        parseInt(this.user.appoin_year) -
          543 +
          "-" +
          this.user.appoin_month +
          "-" +
          this.user.appoin_day
      );

      // MUST have "this."
      return this._calcAge(today, DOB);
    },
    get_gov_Age_year() {
      // 2. Add safety guard to prevent .getFullYear() from crashing
      if (!this.date_month_cal || !this.user.date_app_now) return 0;

      let today = new Date(this.date_month_cal);
      let DOB = new Date(this.user.date_app_now);

      // Ensure both are valid dates before extracting the year
      if (isNaN(today) || isNaN(DOB)) return 0;

      let years = today.getFullYear() - DOB.getFullYear();
      if (
        DOB.getMonth() > today.getMonth() ||
        (DOB.getMonth() === today.getMonth() && DOB.getDate() > today.getDate())
      ) {
        years--;
      }
      return years;
    }
  }
};
</script>

<style lang="scss" scoped></style>
